// extracted by mini-css-extract-plugin
export default {"root":"viewer_root__tatG8"};